import { GrupolocalService } from "./../../services/grupolocal.service";
import { GrupoLocalNivel1 } from "./../domain/domain.model";

import { AfterContentInit, Component, OnInit } from "@angular/core";
import { UsuarioAutorizacoes } from "src/app/models/usuario.autorizacoes.model";
import { DashboardService } from "src/app/services/dashboard.service";
import { UsuarioService } from "src/app/services/usuario.service";
import { APP_SETTINGS } from "src/environments/environment";
import { DashboardUmParameters } from "../domain/viewmodels.models";
import { OSService } from "src/app/services/os-service";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
  providers: [DashboardService],
})
export class DashboardComponent implements OnInit, AfterContentInit {
  constructor(
    private dashboardService: DashboardService,
    private usuarioService: UsuarioService,
    private grupoLocalService: GrupolocalService,
    private osService: OSService
  ) {}

  
  parameters: DashboardUmParameters = {
    meses: String(new Date().getMonth() + 1),
    ano: new Date().getFullYear().toString(),
    tiposDeOSFilha: "",
    grupoLocalNivel1Id: 0,
    mesDiaInicial: `${String(new Date().getMonth() + 1)}-01`,
    periodo: "periodoAno",
    dataInicial: "",
    dataFinal: "",
    tipoOSs: ""
  };

  dashboard: any = undefined;
  validacoes: { ano: string; dataInicial: string; dataFinal: string } = {
    ano: "",
    dataInicial: "",
    dataFinal: "",
  };

  pendenciasCategories: string[] = [];
  pendenciasData: number[] = [];
  falhasCategories: string[] = [];
  falhasData: number[] = [];
  locaisCategories: string[] = [];
  locaisData: number[] = [];
  tipoOSSeries: number[] = [0];
  tipoOSSeriesGeradas: number[] = [0];
  tipoOSLabels: string[] = [];
  classificacaoOSs: string[] = [];
  areasTecnicasSeries: number[] = [];
  areasTecnicasSeriesGeradas: number[] = [];
  areasTecnicasLabels: string[] = [];
  areasTecnicas: string[] = [];
  areasTecnicasColors: string[] = [];
  autorizacoes: UsuarioAutorizacoes;
  tipoInstalacaoApp = APP_SETTINGS.tipoInstalacao;
  exibirQuadroFalhasEmDashboard = APP_SETTINGS.exibirQuadroFalhasEmDashboard;

  tiposOSs: any[] = [];


  tituloCardResumo1 = "";
  tituloCardResumo2 = "";
  tituloCardResumo3 = "";
  tituloCardResumo4 = "";

  valorCardResumo1 = 0;
  valorCardResumo2 = 0;
  valorCardResumo3 = 0;
  valorCardResumo4 = 0;

  valorAntesPeriodo = 0;
  valorBolsaPeriodo = 0;

  optionsChartPendencias: any = undefined;
  optionsChartFalhas: any = undefined;
  optionsChartLocais: any = undefined;

  optionsChartOSClassificacao: any = undefined;
  optionsChartOSAreaTecnica: any = undefined;

  public isProcessing: boolean = false;
  public isLoadingGruposLocais: boolean = false;

  public gruposLocais: GrupoLocalNivel1[] = [];

  typeChart01: string = "bar"; // bar ou pie
  typeChart02: string = "bar"; // bar ou pie

  public showDetails: boolean = false;

  ngAfterContentInit(): void {
    this.autorizacoes =
      this.usuarioService.getAutorizacoesJanelaPorRota("dashboard");
  }

  ngOnInit() {
    this.getGruposLocais();
    let i = 1;
    
    Array.from(document.getElementsByClassName("mes")).forEach((e) => {
      if (i == Number(this.parameters.meses)) {
        e.classList.add("bg-info");
      }
      i++;
    });
    
    this.getTiposOSs();
    
  }

  getGruposLocais() {
    this.isLoadingGruposLocais = true;
    this.grupoLocalService
      .getAll()
      .then((res) => {
        this.gruposLocais = res;
        this.isLoadingGruposLocais = false;
      })
      .catch((error) => {
        this.isLoadingGruposLocais = false;
      });
  }

  getTiposOSs() {
  this.osService.GetTiposOSs().subscribe((response: any[]) => {
    this.tiposOSs = response;
    //console.log(this.tiposOSs);
    this.tiposOSs.map(x => {
      this.classificacaoOSs.push(x.descricao);
    });

    this.selecionarTipo(undefined, "TODOS");

  })
  }

  changeGrupoLocal(grupoLocalNivel1Id: any) {
    this.parameters.grupoLocalNivel1Id = Number(grupoLocalNivel1Id);
    this.getDashboard();
  }

  selecionarPeriodo(e: any, meses: string, mesDiaInicial: string) {
    if (this.parameters.periodo == "periodoDatas") {
      return;
    }
    Array.from(document.getElementsByClassName("periodo")).forEach((e) => {
      e.classList.remove("bg-info");
    });

    if (this.parameters.meses !== meses) {
      (<HTMLTableCellElement>e.target).classList.add("bg-info");
    } else {
      meses = "";
    }

    if (this.parameters.mesDiaInicial === mesDiaInicial) {
      mesDiaInicial = "01-01";
    }

    this.parameters.meses = meses;
    this.parameters.mesDiaInicial = mesDiaInicial;

    this.getDashboard();
  }

  selecionarTipo(evt: any, tipo: string) {
    if (evt != undefined) {
      Array.from(document.getElementsByClassName("tipo")).forEach((e) => {
        e.classList.remove("bg-info");
      });
      (<HTMLTableDataCellElement>evt.target).classList.add("bg-info");
    }

    this.parameters.tiposDeOSFilha = "";

    if (tipo == "TODOS") {
      if (this.tipoInstalacaoApp == "SS") {
        this.parameters.tiposDeOSFilha = "1, 2"; // SS e Preventiva
        this.tituloCardResumo1 =
          "SSs e Preventivas <br/>solicitadas no período";
        this.tituloCardResumo2 = "SSs e Preventivas <br/>recusadas no período";
        this.tituloCardResumo3 =
          "OSs (SSs e Preventivas)<br/>criadas no período";
      }

      if (this.tipoInstalacaoApp == "PT") {
        this.parameters.tiposDeOSFilha = "1, 3"; // PT e Preventiva
        this.tituloCardResumo1 =
          "PTs e Preventivas <br/>solicitadas no período";
        this.tituloCardResumo2 = "PTs e Preventivas <br/>recusadas no período";
        this.tituloCardResumo3 =
          "OSs (PTs e Preventivas) <br/>criadas no período";
      }

      if (this.tipoInstalacaoApp == "SSPT") {
        this.parameters.tiposDeOSFilha = "1, 2, 3"; // SS, PT e Preventiva
        this.tituloCardResumo1 =
          "SSs, PTS e Preventivas <br/>solicitadas no período";
        this.tituloCardResumo2 =
          "SSs, PTS e Preventivas <br/>recusadas no período";
        this.tituloCardResumo3 =
          "OSs (SSs, PTs e Preventivas)<br/>criadas no período";
      }
    } else {
      if (tipo == "PBM") {
        this.parameters.tiposDeOSFilha = "1"; // Preventiva
        this.tituloCardResumo1 = "Preventivas <br/>solicitadas no período";
        this.tituloCardResumo2 = "Preventivas <br/>recusadas no período";
        this.tituloCardResumo3 = "OSs (Preventivas) criadas <br/>no período";
      }

      if (tipo == "SS") {
        this.parameters.tiposDeOSFilha = "2"; // SS
        this.tituloCardResumo1 = "SSs <br/>solicitadas no período";
        this.tituloCardResumo2 = "SSs <br/>recusadas no período";
        this.tituloCardResumo3 = "OSs (SSs) <br/>criadas no período";
      }

      if (tipo == "PT") {
        this.parameters.tiposDeOSFilha = "3"; // PT
        this.tituloCardResumo1 = "PTs <br/>solicitadas no período";
        this.tituloCardResumo2 = "PTs <br/>recusadas no período";
        this.tituloCardResumo3 = "OSs PTs <br/>criadas no período";
      }

      if (tipo == "SS_PT") {
        this.parameters.tiposDeOSFilha = "2, 3"; // PT
        this.tituloCardResumo1 = "SSs e PTs <br/>solicitadas no período";
        this.tituloCardResumo2 = "SSs e PTs <br/>recusadas no período";
        this.tituloCardResumo3 = "OSs SSs/PTs <br/>criadas no período";
      }
    }

    this.getDashboard();
  }

  selecionarAno() {
    this.validacoes.ano = "";
    const ano = Number(
      (<HTMLInputElement>document.getElementById("ano")).value
    );

    if (ano == 0) {
      this.validacoes.ano = "O ano deve ser informado";
      this.parameters.ano = "";
      return;
    }

    if (ano < 2000 || ano > new Date().getFullYear()) {
      this.validacoes.ano = "Ano inválido";
      this.parameters.ano = ano.toString();
      return;
    }

    this.parameters.ano = ano.toString();
    this.getDashboard();
  }

  selecionarDatas() {
    this.validacoes.dataInicial = "";
    this.validacoes.dataFinal = "";
    this.parameters.dataInicial = "";
    this.parameters.dataFinal = "";

    let dataInicial = (<HTMLInputElement>document.getElementById("dataInicial"))
      .value;
    let dataFinal = (<HTMLInputElement>document.getElementById("dataFinal"))
      .value;

    if (!dataInicial) {
      this.validacoes.dataInicial = "informe uma data válida";
    } else {
      this.parameters.dataInicial = dataInicial;
    }

    if (!dataFinal) {
      this.validacoes.dataFinal = "informe uma data válida";
    } else {
      this.parameters.dataFinal = dataFinal;
    }

    if (!dataInicial || !dataFinal) {
      return;
    }

    if (new Date(dataFinal).getTime() < new Date(dataInicial).getTime()) {
      [dataInicial, dataFinal] = [dataFinal, dataInicial];
    }

    this.parameters.dataInicial = dataInicial;
    this.parameters.dataFinal = dataFinal;

    this.getDashboard();
  }

  getDashboard() {
    this.isProcessing = true;

    this.dashboardService
      .getDashboardUm(this.parameters)
      .subscribe((response) => {
        
        this.dashboard = response;

        this.valorCardResumo3 = this.dashboard.qtdeOSsGeradas;
        this.valorCardResumo4 = this.dashboard.porcentualRealizacao;

        if (this.parameters.tiposDeOSFilha == "1") {
          this.valorCardResumo1 = this.dashboard.qtdePBMsGeradas;
          this.valorCardResumo2 = 0; // No modelo atual não há rejeição de PBM
          this.valorAntesPeriodo = this.dashboard.qtdeOSsGeradasAnt;
        }

        if (this.parameters.tiposDeOSFilha == "2") {
          this.valorCardResumo1 =
            this.dashboard.qtdeSPVsGeradas + this.dashboard.qtdeSPVsAprovadas;
          this.valorCardResumo2 = this.dashboard.qtdeSPVsRecusadas;
          this.valorAntesPeriodo = this.dashboard.qtdeSPVsGeradasAnt;
        }

        if (this.parameters.tiposDeOSFilha == "3") {
          this.valorCardResumo1 =
            this.dashboard.qtdePTsGeradas + this.dashboard.qtdePTsAprovadas;
          this.valorCardResumo2 = this.dashboard.qtdePTsRecusadas;
          this.valorAntesPeriodo = this.dashboard.qtdePTsGeradasAnt;
        }

        if (this.parameters.tiposDeOSFilha == "1, 2") {
          this.valorCardResumo1 =
            this.dashboard.qtdePBMsGeradas +
            this.dashboard.qtdeSPVsGeradas +
            this.dashboard.qtdeSPVsAprovadas;
          this.valorCardResumo2 = this.dashboard.qtdeSPVsRecusadas;
          this.valorAntesPeriodo =
            this.dashboard.qtdeSPVsGeradasAnt +
            this.dashboard.qtdeOSsGeradasAnt;
        }

        if (this.parameters.tiposDeOSFilha == "2, 3") {
          this.valorCardResumo1 =
            this.dashboard.qtdeSPVsGeradas +
            this.dashboard.qtdeSPVsAprovadas +
            (this.dashboard.qtdePTsGeradas + this.dashboard.qtdePTsAprovadas);

          this.valorCardResumo2 =
            this.dashboard.qtdeSPVsRecusadas + this.dashboard.qtdePTsRecusadas;

          this.valorAntesPeriodo =
            this.dashboard.qtdeSPVsGeradasAnt +
            this.dashboard.qtdePTsGeradasAnt;
        }

        if (this.parameters.tiposDeOSFilha == "1, 3") {
          this.valorCardResumo1 =
            this.dashboard.qtdePBMsGeradas +
            this.dashboard.qtdePTsGeradas +
            this.dashboard.qtdePTsAprovadas;
          this.valorCardResumo2 = this.dashboard.qtdePTsRecusadas;
          this.valorAntesPeriodo =
            this.dashboard.qtdePTsGeradasAnt + this.dashboard.qtdeOSsGeradasAnt;
        }

        if (this.parameters.tiposDeOSFilha == "1, 2, 3") {
          this.valorCardResumo1 =
            this.dashboard.qtdePBMsGeradas +
            this.dashboard.qtdeSPVsGeradas +
            this.dashboard.qtdePTsGeradas;
          this.valorCardResumo2 =
            this.dashboard.qtdeSPVsRecusadas + this.dashboard.qtdePTsRecusadas;
          this.valorAntesPeriodo =
            this.dashboard.qtdeSPVsGeradasAnt +
            this.dashboard.qtdePTsGeradasAnt +
            this.dashboard.qtdeOSsGeradasAnt;
        }

        this.valorBolsaPeriodo = this.valorAntesPeriodo + this.valorCardResumo1;

        this.pendenciasCategories = this.dashboard.pendenciasDetectadas.map(
          (t) => t.descricao
        );
        this.pendenciasData = this.dashboard.pendenciasDetectadas.map(
          (t) => t.qtde
        );

        this.falhasCategories = this.dashboard.falhasDetectadas.map(
          (t) => t.descricao
        );
        this.falhasData = this.dashboard.falhasDetectadas.map((t) => t.qtde);

        this.locaisCategories = this.dashboard.locaisVisitados.map(
          (t) => t.descricao
        );
        this.locaisData = this.dashboard.locaisVisitados.map((t) => t.qtde);

        this.tipoOSLabels = [];
        this.tipoOSSeries = [];
        this.tipoOSSeriesGeradas = [];


        this.tiposOSs.map(x => {
          this.tipoOSLabels.push(`${x.descricao}(${this.dashboard.oSsPorTipoOS[x.descricao.toLowerCase().replace('ã', 'a').replace('ç', 'c').replace('õ', 'o')]})`);
          this.tipoOSSeries.push(this.dashboard.oSsPorTipoOS[x.descricao.toLowerCase().replace('ã', 'a').replace('ç', 'c').replace('õ', 'o')]);
          this.tipoOSSeriesGeradas.push(this.dashboard.oSsGeradasPorTipoOS[x.descricao.toLowerCase().replace('ã', 'a').replace('ç', 'c').replace('õ', 'o')])

        })


        this.areasTecnicasSeries = this.dashboard.areasTecnicas.map((t) =>
          Number(t.qtde)
        );
   

        this.areasTecnicasSeriesGeradas = this.dashboard.areasTecnicasGeradas.map((t) =>
          Number(t.qtde)
        );
        this.areasTecnicasLabels = this.dashboard.areasTecnicasGeradas.map(
          (t) => `${t.descricao} (${t.qtde})`
        );
        this.areasTecnicas = this.dashboard.areasTecnicasGeradas.map(
          (t) => `${t.descricao} `
        );


        this.areasTecnicasColors = [
          "#2C84A0",
          "#F7CD48",
          "#014A89",
          "#F75226",
          "#71CEDA",
          "#F3C9C0",
          "#70AD3E",
          "#EC2A77",
          "#4F6D45",
          "#D7AB8F",
          "#5A1F7E",
        ];

        this.optionsChartPendencias = {
          series: [{ name: "", data: this.pendenciasData }],
          chart: { height: "250", type: "bar" },
          plotOptions: {
            bar: {
              horizontal: true,
              barHeight: "60%",
              dataLabels: { position: "top", hideOverflowingLabels: true },
            },
          },
          xaxis: {
            categories: this.pendenciasCategories,
          },
          dataLabels: { enabled: true, style: {fontWeight: 700, colors: ['#000']}, offsetX: 10  },
        };

        this.optionsChartFalhas = {
          series: [{ name: "", data: this.falhasData }],
          chart: { height: "250", type: "bar" },
          plotOptions: {
            bar: {
              horizontal: true,
              barHeight: "60%",
              dataLabels: { position: "top", hideOverflowingLabels: true },
            },
          },
          xaxis: { categories: this.falhasCategories },
          dataLabels: { enabled: true, style: {fontWeight: 700, colors: ['#000']}, offsetX: 10  },
        };

        this.optionsChartLocais = {
          series: [{ name: "", data: this.locaisData }],
          chart: { height: "250", type: "bar" },
          plotOptions: {
            bar: {
              horizontal: true,
              barHeight: "60%",
              dataLabels: { position: "top", hideOverflowingLabels: true },
            },
          },
          xaxis: { categories: this.locaisCategories },
          dataLabels: { enabled: true, style: {fontWeight: 700, colors: ['#000']}, offsetX: 15  },
        };

        this.showGraphOSClassificacao();
        this.showGraphOSAreaTecnica();

        this.isProcessing = false;
      });
  }

  changeTypeChart01(type: string) {
    if (type === this.typeChart01) {
      return;
    }

    this.typeChart01 = type;
    this.showGraphOSClassificacao();
  }

  changeTypeChart02(type: string) {
    if (type === this.typeChart02) {
      return;
    }

    this.typeChart02 = type;
    this.showGraphOSAreaTecnica();
  }

  showGraphOSClassificacao() {
    if (this.typeChart01 == "bar") {
     
      this.optionsChartOSClassificacao = {
        series: [{ name: "Executadas", data: this.tipoOSSeries }, {name: "Geradas", data: this.tipoOSSeriesGeradas  } ],
        chart: { height: "350", type: "bar" },
        xaxis: { categories: this.classificacaoOSs },
        yaxis: { min: 0, forceNiceScale: true },
        dataLabels: { style: { fontWeight: 700, colors: ["#000"] }, offsetY: -20 },
        plotOptions: {
          bar: {
            dataLabels: {
              position: "top" // top, center, bottom
            }
          }
        },
      };
    }

    if (this.typeChart01 == "pie") {
      this.optionsChartOSClassificacao = {
        series: this.tipoOSSeries,
        chart: { height: "350", type: "donut" },
        labels: this.tipoOSLabels,
        dataLabels: { enabled: true },
        autoUpdateSeries: true,
        
      };
    }
  }

  showGraphOSAreaTecnica() {
    if (this.typeChart02 == "bar") {
      this.optionsChartOSAreaTecnica = {
        series: [{ name: "Executadas", data: this.areasTecnicasSeries }, {name: "Geradas", data: this.areasTecnicasSeriesGeradas}],
        chart: { height: "350", type: "bar" },
        xaxis: {
          categories: this.areasTecnicas,
          labels: { show: true, rotate: -90, rotateAlways: true },
        },
        yaxis: { min: 0, forceNiceScale: true },
        dataLabels: { style: { fontWeight: 700, colors: ["#000"] }, offsetY: -20 },
        plotOptions: {
          bar: {
            dataLabels: {
              position: "top" // top, center, bottom
            }
          }
        },
      };
    }

    if (this.typeChart02 == "pie") {
      this.optionsChartOSAreaTecnica = {
        series: this.areasTecnicasSeries,
        chart: { height: "350", type: "donut" },
        labels: this.areasTecnicasLabels,
        dataLabels: { enabled: true },
        autoUpdateSeries: true,
        colors: this.areasTecnicasColors,
      };
    }
  }

  setFilterTime(periodo) {
    this.validacoes.ano = "";
    this.validacoes.dataInicial = "";
    this.validacoes.dataFinal = "";
    this.parameters.periodo = periodo;

    if (periodo === "periodoDatas") {
      Array.from(document.getElementsByClassName("periodo bg-info")).forEach(
        (e) => {
          e.classList.remove("bg-info");
          e.classList.add("bg-secondary");
        }
      );

      if (this.parameters.dataInicial && this.parameters.dataFinal) {
        this.getDashboard();
      }
    }

    if (periodo === "periodoAno") {
      Array.from(
        document.getElementsByClassName("periodo bg-secondary")
      ).forEach((e) => {
        e.classList.remove("bg-secondary");
        e.classList.add("bg-info");
      });

      if (this.parameters.ano) {
        this.getDashboard();
      }
    }
  }
}
